export const apiHeaders = {
    "X-API-KEY": process.env.REACT_APP_API_KEY,
    Authorization: "",
    "Content-Type": "application/json",
    accept: "application/json",
};

export const baseApiUrl = process.env.REACT_APP_API_URL;
export const manageISSNUrl = process.env.REACT_APP_MANAGE_URL;
